module.exports = __webpack_public_path__ + "img/5.40ebfa4c.png";